import BuildingInfo from './BuildingInfo';
export default BuildingInfo;
